<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { notify } from 'src/plugins/notify'
import { required, requiredUnless, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import { driversLicense, hasOne, requiredIfSync, driversLicenseError, isDate, requireClassAddress } from 'src/utils/validators'
import ClassSessionDetails from './ClassSessionDetails'
import ClassStudentDetails from './ClassStudentDetails'
import ClassCertificates from './ClassCertificates'
import ClassPayments from './ClassPayments'
import ClassDocuments from './ClassDocuments'
import { lkKey } from 'src/utils'
import ConfirmModal from '../Global/ConfirmModal.vue'

const moment = require('moment')

export default {
    components: {
        ClassSessionDetails,        
        ClassStudentDetails,
        ClassDocuments,
        ClassCertificates,
        ClassPayments,
        ConfirmModal
    },
    async mounted () {
      let vm = this
      vm.setEditAbility()
      vm.$root.$on('updateClassesModalEditState', () => {
          vm.setEditAbility()
      })
      vm.maximized = false

      const options = {
        customFilter: [{
          field: 'ENTITY_ITEM_ID',
          filter: vm.sessionInformation.classId,
        }]
      }

      await this.fetch(options)
      if (this.mode !== 'add' && this.documentList.length === 0) {
        this.showConfirmModal = true
      }
    },
    validations () {
        let vm = this,
            currentSessionAddress = vm.currentSessionOrFirst('Address')
            
        return {
            sessionInformation: {
                selectedAffiliate: { required },
                // selectInstructor: { required },
                selectedCourse: { required },
                selectedClassType: { required },
                // selectInstructor: { required },
                sessions: {
                    $each: {
                        startDate: { required },
                        startHour: { required },
                        startMin: { required },
                        startPeriod: { required },
                        endDate: { required },
                        endHour: { required },
                        endMin: { required },
                        endPeriod: { required },
                        // ****** IMPORTANT *******
                        // We cannot add address validation because
                        // Vuelidate is not aware of the syncing flags
                        // address1: {}, // { requireClassAddress: requireClassAddress(currentSessionAddress.address1) },//required },
                        // city:  {}, //{ requireClassAddress: requireClassAddress(currentSessionAddress.city) },//required },
                        // state:  {}, //{ requireClassAddress: requireClassAddress(currentSessionAddress.state) },//required },
                        // zip:  {}, //{ requireClassAddress: requireClassAddress(currentSessionAddress.zip) },//required, minLength: minLength(5), maxLength: maxLength(5), numeric },
                        // county:  {}, //{ requireClassAddress: requireClassAddress(currentSessionAddress.county) },//required },
                        // instructors: { 
                        //     $each: {
                        //         value: { required }
                        //     },
                        // },
                        students: { 
                            $each: {
                                dl: { required, driversLicense: driversLicense('dlState') },
                                dlState: { },
                                lastName: { required },
                                firstName: { required },
                                middleName: { },
                                address1: { required },
                                address2: { },
                                city: { required },
                                stateId: { required },
                                zip:  {}, // { required, minLength: minLength(5), maxLength: maxLength(5), numeric },
                                gender: { required },
                                dob: { required, isDate, maxLength: maxLength(10) },
                                completedDate: {  }
                            }
                        }
                    }
                }
            }
        }
    },
    data () {
        // let component = this
        return {            
            saving: false,
            submitting: false,
            moment: moment,
            maximized: false,
            documentCount: 0,            
            validationErrorWhenSaving: false,
            sidebarVisible: true,
            addressError: null,
            oldModule: null,
            showConfirmModal: false,
        }
    },
    created() {
      const vm = this
      vm.oldModule = vm.$route.meta.module
      // we need to change the module here because
      // the class modal can be opened from other modals,
      // like the student one
      // if we don't change the module, using the document grid
      // in the class modal may fetch documents for/upload documents to the student
      // we'll change it back when the class modal is unmounted
      // we should really get rid of this whole meta.module system entirely
      // and just pass the module as a prop to components that need it
      vm.$route.meta.module = 'classes'

      vm.$root.$on('refreshApprovals', () => vm.fetchClassApprovals({
        pagination: vm.approvalPagination,
        columnOptions: vm.approvalColumns,
      }))
    },
    beforeDestroy() {
      // set the meta module back to whatever it was
      // before opening this modal
      this.$route.meta.module = this.oldModule
    },
    computed: {
        ...mapGetters([
            'stateOptions'
        ]),
        ...mapGetters('classes', [
            'dlStateAbbrev'
        ]),
        ...mapGetters('documents', [
          'documentList'
        ]),
        ...mapState('approvals', {
          approvalPagination: s => s.paginationOptions,
          approvalColumns: s => s.columnOptions,
        }),
        ...mapState({
            sessionInformation: s => s.classes.sessionInformation,
            mode: s => s.classes.sessionInformation.mode,
            selectedTab: s => s.classes.selectedTab,
            dateFormat: s => s.shared.formats.datetime,
            loading: s => s.classes.sessionInformation.loading,
            issuing: s => s.classes.issuing,
            classesModalState: s => s.classes.classesModalState,
            canEdit: s => s.classes.canEdit,
            rejectionNotes: s => s.approvals.rejectionNotes,
            affiliates: s => s.classes.sessionInformation.affiliates,
            rereporting: s => s.classes.rereporting
        }),
        validation () {
            return this.$v
        },
        stateAbbrev () {

        },        
        titleLabel () {
            if (this.mode === 'approve'){
                return 'Review Class ' + (this.sessionInformation.classId || "") 
            }
            return this.mode === 'add' ? 'Add Class' : 'Edit Class ' + (this.sessionInformation.classId || "")
        },
        saveLabel () {
            return this.mode === 'add' ? 'Create' : 'Save'
        },
        submitForApprovalLabel () {
            return this.status == 'REJECTED' ? 'Resubmit For Approval' : 'Submit For Approval'
        },
        invalidDetails(){
            let vm = this,
                classInfo = vm.validation.sessionInformation,
                session = classInfo.sessions.$each[vm.currentSession(true)]
            return classInfo.selectedAffiliate.$invalid || classInfo.selectedCourse.$invalid || session.endDate.$invalid
        },
        classTotalStudents () { 
            let students = []
            _.map(this.sessionInformation.sessions,(session, i) => {
                if (!session.syncStudents || i==0) {
                    session.students.map(s => {
                        let findStudent = _.find(students,{dl:s.dl})
                        if(!findStudent) students.push(s)
                    })
                }
            })
            return students.length
        },
        classTotalInstructors () {
            let total = 0
            _.map(this.sessionInformation.sessions,(session, i) => {
                if (!session.syncInstructors || i==0) {
                    total += session.instructors.length
                }
            })
            return total
        },
        showApproveAction () {
            let mode = this.mode
            return ((mode == 'edit') && this.loading && this.submitting) || ((mode == 'edit') && !this.loading)
        },        
        status () {
            return this.approvalDetail(this.activeApproval(),null,true)
        }, 
        leftPaneClasses(){
            let vm = this, 
                col = vm.sidebarVisible ? 'sl-col-3' : 's-col-0'
            col = (vm.selectedTab === 'students' && vm.sidebarVisible) ? 'sl-col-2' : col
            return `${col} navigation sl-vp`
        },
        rightPaneClasses(){
            let vm = this, 
                col = vm.sidebarVisible ? 'sl-col-9' : 's-col-0'
            col = (vm.selectedTab === 'students' && vm.sidebarVisible) ? 'sl-col-10' : col
            return `${col} sl-vp`
        },
        canDelete() {
          return (
            this.sessionInformation.sessions.every(s => s.students.length === 0)
            && this.documentList.length === 0
          )
        }
    },
    methods: {
        ...mapActions('approvals', [
            'fetchClassApprovals'
        ]),
        ...mapActions('documents', ['fetch',]),
        ...mapActions('classes', [
            'upsertCalendarClass',
            'removeSessions',
            'destroyClass',
            'submitClassForApproval',
            'checkoutClass',
            'fetchClasses',
            'loadAffiliates',
            'loadCoursesForAffiliate',
            'loadInstructorsForAffiliate',
            'rereportStudents',
            'deleteClass'
        ]),
        ...mapMutations('classes', [
            'updateSelectedTab',
            'updateAddNewSession',
            'updateAddNewInstructor',
            'updateAutocompleteInstructor',
            'updateAddEditClassOpenState',
            'updateModalLoading',
            'updateEditState'
        ]),
        ...mapMutations('approvals',[
            'updateRejectionNotes'
        ]),
        /*requireClassAddress(value){
            console.log(value,1)
            let vm = this
            return vm.currentSessionOrFirst('Address')[field]
        },*/
        
        $anyStudentError(){
            let vm = this                     
            //return vm.$v.sessionInformation.sessions.$each[vm.currentSessionOrFirst('Students',true)].students.$each.$invalid
            let students = vm.currentSessionOrFirst('Students').students
            let invalidStudents = _.filter(students, (student,i) => {
                let validationObj = vm.$v.sessionInformation.sessions.$each[vm.currentSessionOrFirst('Students',true)].students.$each[i]
                return validationObj.$invalid
             })
            return invalidStudents && invalidStudents.length > 0 ? true : false
        },
        rereportMethod(){
            let vm = this,
                students = vm.validation.sessionInformation.sessions.$each[vm.currentSessionOrFirst('Students', true)].students,
                validStudentsToSearch = _.filter(students.$each, (s,i) => {
                    return !isNaN(i)
                }),
                rereportableStudents = _.filter(validStudentsToSearch, { $anyDirty: true })
            
            // Strip away the validation fluff
            rereportableStudents = _.map(rereportableStudents, s => s.$model)
            
            if(students.$anyError){
                return notify.create({ message:"Please fix student data.", type:'negative' })
            }

            return vm.rereportStudents({ students: rereportableStudents, vm })
        },
        checkoutClassMethod(){
          const vm = this
          vm.updateModalLoading(true)
          vm.save({ notification: false }).then(() => {
            vm.checkoutClass(this)
            vm.updateModalLoading(false)
          })
        },
        setEditAbility () {
            let vm = this,
                status = vm.status
            if(vm.$p(['ADMIN'])){
                return vm.updateEditState(true)
            }
            if( status == 'APPROVED'){
                return vm.updateEditState(false)
            }
            if( status == 'NOT SUBMITTED' || status == 'REJECTED' || (vm.sessionInformation.approvals && vm.sessionInformation.approvals.length == 0 )){
                vm.updateEditState(true)
            }
            else {
                return vm.updateEditState(false)
            }
            if(vm.$p(['RECRUITER']) && !vm.$p(['ADMIN','MANAGER','AFFILIATE'],'or')){
                vm.updateEditState(false)
            }
            vm.forceUpdate()
        },
        allSessionIds () {
            return _.map(this.sessionInformation.sessions, session => {
                return session.sessionId
            })
        },
        // Returns either icon or Approval type
        approvalDetail(approval, isIcon, checkClass){
            if (!approval) return
            let icon
            let approvalStatus = approval.LK_CLASS_APPROVAL_STATUS_ID
            let classStatus = lkKey('LK_CLASS_STATUS_ID', this.sessionInformation.classStatus)
            if(classStatus && !isIcon && checkClass){
                if(classStatus === 'PROCESSED' || classStatus === 'HELD'){
                    return classStatus
                }
            }
            if(!isIcon){
                return lkKey('LK_CLASS_APPROVAL_STATUS_ID', approvalStatus)
            }
            // Need this for history dropdown
            switch(approvalStatus){
                case 1: // Submitted
                    icon = 'move_to_inbox'
                    break
                case 2: // Approved
                    icon = 'done'
                    break
                case 3: // Rejected
                    icon = 'close'
                    break
                case 4: // Expired
                    icon = 'call_missed'
                    break
                case 5: // Resubmitted
                    icon = 'redo'
                    break
            }
            return icon
        },
        onCancel () {
            window.jQuery('.k-scheduler-cancel').click()
            this.updateAddEditClassOpenState(false)
        },
        onRemove (ids) {
            this.$q.dialog(this.removeDialogOptions(ids))
                .then(() => {
                    this.removeSessions(ids)         
                    this.$root.$emit('refreshGrid:classListGrid')         
                })        
        },
        onRemoveClass(){
             this.$q.dialog({
                title: `Removing Entire Class`,
                message: 'Are you sure you want to delete the entire class? This cannot be undone.',
                noBackdropDismiss: true,
                ok: {
                    label: "Yes, I'm Sure.",
                    color: 'positive'
                },
                cancel: {
                    label: 'Cancel',
                    color: 'grey'
                }
            })
                .then(() => {
                    this.destroyClass(this.sessionInformation.classId)   
                    this.$root.$emit('refreshGrid:classListGrid')
                })   
        },
        openUploadModal (LK_DOCUMENT_TYPE_ID) {
          const payload = {
            LK_ENTITY_ID: 4,
            ENTITY_ITEM_ID: this.sessionInformation.classId
          }

          if (LK_DOCUMENT_TYPE_ID) {
            payload.LK_DOCUMENT_TYPE_ID = LK_DOCUMENT_TYPE_ID
          }

          this.$store.dispatch('documents/openUploadModal', payload, { root: true })
        },
        allSessionIds () {
            return _.map(this.sessionInformation.sessions, session => {
                return session.sessionId
            })
        },
        sessionsLabel () {
            let count = this.sessionInformation.sessions.length
            let plural = count > 1 ? "s" : ""
            return `${count} Session${plural} Total &bull; ${this.classTotalStudents} Total Students`
        },
        forceUpdate (ms) {
            let parent = this
            setTimeout(() => {
                parent.$forceUpdate()
            }, ms || 250)
        },
        currentSession (findIndex) {
            var filter = findIndex === true ? "findIndex" : "find"
            return _[filter](this.sessionInformation.sessions, {value: this.sessionInformation.selected})
        },
        currentSessionOrFirst (type, returnSessionIndex) {
            let firstSession = this.sessionInformation.sessions[0]
            let syncType = this.currentSession()[`sync${type}`]
            if (returnSessionIndex) {
                return (syncType === true) ? 0 : this.currentSession(true)
            }
            return (syncType === true) ? firstSession : this.currentSession() 
        },
        activeApproval () {
            return this.sessionInformation.approvals && this.sessionInformation.approvals[0]
        },
        async submitForApprovalMethod ({ id, status }) {
            let vm = this

            // TODO uncomment the below after
            // AWS bucket issue is fixed
            // cannot approve a class without at least one doc
            // if (status == 2 && this.documentList.length === 0) {
            //     return notify.create({
            //         message: 'Please add at least 1 document!',
            //         type: 'negative'
            //     })
            // }
            if (this.documentList.length === 0) {
              this.showConfirmModal = true
              return
            }

            if (this.classTotalStudents === 0 && vm.mode !== "approve") {
                return notify.create({
                    message: 'Please add at least 1 student!',
                    type: 'negative'
                })
            }
            
            if (status === 3 && !vm.rejectionNotes){
                return notify.create({
                    message: 'Please add rejection notes!',
                    type: 'negative'
                })
            }


            if (!vm.saving) {
                vm.submitting = true
                vm.updateModalLoading(true)
                vm.save({ notification: false })
                    .then(()=>{
                        vm.submitClassForApproval({ id: id, status: status, notes: this.rejectionNotes })
                            .then(res => {
                                if (!res) {
                                  return
                                }

                                let success = res.data.success
                                if(success){
                                    vm.submitting = false
                                    vm.updateModalLoading(false)
                                    vm.updateAddEditClassOpenState(false)
                                    vm.$root.$emit('refreshGrid:classListGrid')
                                    vm.$root.$emit('refreshGrid:classApprovalsGrid')
                                }    

                                notify.create({
                                    message: res.data.message,
                                    type: success ? 'positive' : 'negative',
                                    position: 'center'
                                })            
                            })
                    })
                    .catch((err)=>{
                        vm.submitting = false
                        vm.updateModalLoading(false)
                    })
                    .finally(() => {
                      vm.submitting = false
                    })
                
            }
        },
        uploadRoster() {
          this.updateSelectedTab("documents")
          this.openUploadModal(1) // Document Type ROSTER
        },
        save ({ notification = true }) {
            let vm = this

            // Validations
            vm.validation.sessionInformation.$touch()

            let validationError = vm.validation.sessionInformation.$invalid
            vm.validationErrorWhenSaving = validationError
            if(validationError){
                let $modalRight = $("#class-modal-right")
                if($modalRight.length > 0){
                    let $foundErrors = $modalRight.find(".q-field-with-error")    
                    if($foundErrors.length > 0){
                        // Only certain browsers support this.
                        if($foundErrors[0].scrollIntoView){
                            $foundErrors[0].scrollIntoView({ behavior: 'smooth' })
                        }
                    }
                }
                return Promise.reject("Please correct all errors.")
            } 

            // check address without vuelidate
            this.addressError = this.checkAddresses()
            if (this.addressError) {
              this.validationErrorWhenSaving = true
              return
            }

            this.validationErrorWhenSaving = false

            if (!vm.saving) {
                vm.saving = true
                if ( vm.classTotalInstructors == 0 ) {
                    vm.saving = false
                    return notify.create({
                            message: 'Please add at least one instructor in a session!',
                            type: 'negative'
                        })
                }
                return vm.upsertCalendarClass()
                    .then(res => {
                        let success = res.data.success 
                        vm.saving = false
                        if (success === true) {
                            this.$store.commit('classes/updateModalMode', this.mode)
                            vm.$root.$emit('schedulerRefresh')
                            let path = vm.$route.path

                            // Refresh classes list
                            if(path === '/classes/list'){
                                //vm.fetchClasses({})
                                vm.$root.$emit('refreshGrid:classListGrid')
                            }
                            else if(path === '/approvals/classes'){
                                vm.$root.$emit('refreshGrid:classApprovalsGrid')
                            }
                            if (this.mode==="add") {
                                this.$store.commit('classes/storeClassId',res.data.data.CLASS_ID)
                                setTimeout(function(){
                                    vm.$root.$emit('reloadClassDetailsModal') 
                                })
                            }
                            vm.updateAddEditClassOpenState(false);
                            if(notification){
                                notify.create({
                                    message: res.data.message,
                                    type: "positive"
                                })
                            }
                            return Promise.resolve()
                        } else {
                            if(notification){
                                let type = this.mode === "add" ? "creating" : "saving" 
                                notify.create({
                                    message: `Error ${type} class.`,
                                    type: "negative"
                                })
                            }
                            return Promise.reject("Error when saving class.")
                        }                        
                    })
            }
            return Promise.resolve()
        },
        payForClass () {

        },
        removeDialogOptions (ids) {
            let message = `Are you sure you want to remove ${this.currentSession().label}?`
            let titleText = 'Session'
            if (ids.length > 1 || this.sessionInformation.sessions.length == 1) {
                message = `You are about to remove this entire Class, are you sure?`
                titleText = 'Entire Class'
            }
            return {
                title: `Remove ${titleText}`,
                message: message,
                noBackdropDismiss: true,
                ok: {
                    label: "Yes, I'm Sure.",
                    color: 'positive'
                },
                cancel: {
                    label: 'Cancel',
                    color: 'grey'
                }
            }
        },
        toggleMaximized(){
            this.maximized = !this.maximized
        },
        toggleSidebar(){
            this.sidebarVisible = !this.sidebarVisible
        },
        delClass() {
          this.deleteClass({ classId: this.sessionInformation.classId })
        },
        checkAddresses() {
          const [head, ...tail] = this.sessionInformation.sessions

          function checkFields(session, idx) {
            const error = {
              fields: [],
              sessionIdx: idx,
            };

            ['address1', 'city', 'state', 'zip', 'county'].forEach(field => {
              if (!session[field]) {
                error.fields.push(field)
              }
            })

            return error.fields.length ? error : null
          }

          let error = null
          // head _must_ have an address
          if (head) {
            error = checkFields(head, 0)
          }

          if (error) {
            return error
          }

          // any tail session may not have an address _if_ sync address is on
          tail.some((session, idx) => {
            if (!session.syncAddress) {
              error = checkFields(session, idx + 1)
            }

            // stop checking session as soon as one fails
            return error === null
          })

          return error
        },
        closeConfirmModal() {
          this.showConfirmModal = false
        },
        onConfirm() {
          this.closeConfirmModal()
          this.uploadRoster()
        },
  }
}
</script>

<template>
  <q-modal class="sl-modal"
    id="classDetailsModal"
    :value="classesModalState"
    v-if="classesModalState"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :content-css="{width: (selectedTab === 'students') ? '99vw' : '1400px', maxWidth: '100%', minHeight: '75vh'}"
    :class="{'loading': loading}"
    :maximized="maximized"
    >
    <q-modal-layout>
        <q-toolbar slot="header">
            <q-toolbar-title>
                <q-icon name="fa fa-slideshare" /> {{titleLabel}}
                <div style="display:inline-block;margin-left: 10px;border-radius:30px"
                    class="label outline"
                    :class="{
                        'blue': status =='RESUBMITTED' || status =='SUBMITTED',
                        'yellow':status =='HELD',
                        'green' : status =='APPROVED' || status =='PROCESSED',
                        'red' : status =='REJECTED'
                    }"
                    v-if="this.sessionInformation.approvals && this.sessionInformation.approvals.length && !loading">
                        {{status}}
                </div>
                <div v-if="status=='REJECTED' && activeApproval().NOTES" style="display:inline-block">
                    <q-icon name="fa fa-question-circle" outlined color="negative" size="45px" style="margin-left:5px">
                        <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"><h6 style="font-size:16px; font-weight: bold; text-transform:uppercase; border-bottom:1px solid #888; padding-bottom: 4px;margin-bottom:4px;">Rejection Reason:</h6><p style="font-size:20px">{{activeApproval().NOTES}}</p></q-tooltip>
                    </q-icon>
                </div>
            </q-toolbar-title>
            <q-btn-dropdown class="approval-history" icon="access time" v-if="this.sessionInformation.approvals && this.sessionInformation.approvals.length > 0">
                <q-list v-for="(approval,i) in this.sessionInformation.approvals" :key="i">
                    <q-item v-close-overlay>
                        <q-item-side :icon="approvalDetail(approval, true)" />
                        <q-item-main>
                            <q-item-tile label>
                                {{approvalDetail(approval)}}
                            </q-item-tile>
                            <q-item-tile sublabel :title="moment(approval.DATE_CREATED).format('llll')">
                                {{moment(approval.DATE_CREATED).calendar()}}
                            </q-item-tile>
                        </q-item-main>
                    </q-item>
                </q-list>
            </q-btn-dropdown>
            <q-btn-dropdown icon="more vert" v-if="!loading && !submitting && (canEdit || $p(['ADMIN'])) && mode != 'add'">
                <q-list link>
                    <q-item @click.native="onRemoveClass()" v-close-overlay>
                        <q-item-main>
                            <q-item-tile label><q-icon name="fa fa-trash" color="red" /> Delete Class</q-item-tile>
                        </q-item-main>
                    </q-item>
                </q-list>
            </q-btn-dropdown>
            <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
            <q-icon v-show="!submitting" @click.native="onCancel" name="clear" />
        </q-toolbar>
        <div class="sl-row sl-abs">
            <div @click="toggleSidebar()" class="collapser"><i class="fa" :class="sidebarVisible ? 'fa-angle-left' : 'fa-angle-right'"></i></div>
            <div :class='leftPaneClasses' v-if="sidebarVisible">
                <q-btn icon="add" id="addSession" @click="updateAddNewSession()" v-if="canEdit">
                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">Add a Session</q-tooltip>
                </q-btn>
                <q-select id="sessionDropdown"
                    v-model="sessionInformation.selected"
                    :float-label="sessionsLabel()"
                    :options="sessionInformation.sessions" />
                <q-list highlight>
                    <q-item :class="{active:selectedTab === 'details'}" @click.native="updateSelectedTab('details')">
                        <q-item-main label="Details" />
                        <q-item-side left>
                            <q-icon style="margin-right:6px" v-if="invalidDetails"  name="fa fa-flag" color="red"></q-icon>                            
                        </q-item-side>
                    </q-item>
                    <q-item :class="{active:selectedTab === 'students'}" @click.native="updateSelectedTab('students')">
                        <q-item-main label="Students" />
                        <q-item-side left>
                            <q-icon style="margin-right:6px" v-if="$anyStudentError()"  name="fa fa-flag" color="red"></q-icon>
                            <div class="label round small ">{{currentSessionOrFirst('Students').students.length}}</div>
                        </q-item-side>
                    </q-item>
                    <q-item v-if="this.mode !== 'add'" :class="{active:selectedTab === 'documents'}" @click.native="updateSelectedTab('documents')">
                        <q-item-main label="Documents" />
                        <!-- <q-item-side right>
                            <div class="label round small ">{{ documentCount }}</div>
                        </q-item-side> -->
                    </q-item>
                    <q-item :class="{active:selectedTab === 'certificates'}" @click.native="updateSelectedTab('certificates')" v-if="sessionInformation.certificates.length > 0 ">
                        <q-item-main label="Certificates" />
                        <q-item-side left>
                            <div class="label round small ">{{sessionInformation.certificates.length}}</div>
                        </q-item-side>
                    </q-item>
                    <q-item :class="{active:selectedTab === 'payments'}" @click.native="updateSelectedTab('payments')" v-if="sessionInformation.orders.length > 0 ">
                        <q-item-main label="Payments" />
                        <q-item-side left>
                            <div class="label round small ">{{sessionInformation.orders.length}}</div>
                        </q-item-side>
                    </q-item>
                    <q-item id="class-code" v-if="mode != 'add'">
                        <q-field icon="memory">
                            <h6>Class Code</h6>
                            <span class="font-weight-bolder">{{sessionInformation.code}}</span>
                        </q-field>
                    </q-item>
                </q-list>
            </div>
            <div id="class-modal-right" :class="rightPaneClasses"  style="padding-bottom:60px">
                <!-- Details -->
                <div v-if="selectedTab === 'details'">
                    <class-session-details :validation="validation" :addressError="addressError" />
                </div>
                <!-- Students -->
                <div id="studentContainer" v-if="selectedTab === 'students'">
                    <class-student-details :validation="validation" />
                </div>
                <!-- Documents -->
                <div v-if="selectedTab === 'documents'">
                    <class-documents :count.sync="documentCount"/>
                </div>
                <!-- Certificates -->
                <div v-if="selectedTab === 'certificates'">
                    <class-certificates />
                </div>
                <div v-if="selectedTab === 'payments'">
                    <class-payments />
                </div>
            </div>
        </div>
        <q-toolbar slot="footer">
            <div v-if="($p(['ADMIN']) && status) || ($p(['MANAGER']) && status && mode =='approve')">
                <q-btn
                    label="Approve"
                    icon="done"
                    color="positive"
                    v-if="status != 'APPROVED' && status != 'PROCESSED' && $p(['ADMIN','MANAGER'],'or')"
                    @click.native="submitForApprovalMethod({id:sessionInformation.classId, status: 2})" />&nbsp;
                <q-btn-dropdown
                    v-if="status != 'REJECTED' && $p(['ADMIN','MANAGER'],'or')"
                    label="Reject"
                    outline
                    icon="clear"
                    style="margin-right:6px"
                    color="negative">
                    <q-list id="rejectionOverlay">
                        <q-item>
                            <div class="reject-notes">
                                <q-input
                                    stack-label="Rejection Notes*"
                                    type="textarea"
                                    :value="rejectionNotes"
                                    @input="val => updateRejectionNotes(val)"
                                 />
                                <q-btn
                                    label="Reject"
                                    icon="clear"
                                    color="negative"
                                    @click.native="submitForApprovalMethod({id:sessionInformation.classId, status: 3})"
                                />
                                <q-btn
                                    label="Cancel"
                                    outline
                                    v-close-overlay />
                            </div>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </div>
            <q-btn color="primary"
                outline
                @click.native="submitForApprovalMethod({id:sessionInformation.classId, status: status == 'REJECTED' ? 5 : 1})"
                :label="submitForApprovalLabel"
                v-if="((showApproveAction && !activeApproval() && canEdit) || status=='REJECTED') && $p(['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or')"
                :loading="submitting"
                :disable="submitting" />       
            <q-btn color="purple"
                class="q-ml-sm"
                outline
                @click.native="uploadRoster"
                label="Upload Roster"
                v-if="((showApproveAction && !activeApproval() && canEdit) || status=='REJECTED') && $p(['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or')"
                :loading="submitting"
                :disable="submitting" />
            <q-btn color="primary" 
                outline
                label="Process Class"
                v-if="status == 'APPROVED'"
                :disabled="issuing"
                @click="checkoutClassMethod()" />       
            <q-toolbar-title></q-toolbar-title>
            <span class="text-red" v-if="validationErrorWhenSaving">
                
                <i class="fa fa-warning"></i> Please correct all errors!&nbsp;&nbsp;
            </span>    
            <div class="q-px-sm" v-if="selectedTab === 'documents' && (!status || status === 'Not Submitted' || status == 'REJECTED')"> 
                <q-btn 
                    class="q-px-md"
                    label="Upload"
                    color="green"
                    @click="openUploadModal()" /> 
            </div> 
            <q-btn
              color="green"
              @click="save"
              v-show="!loading && canEdit"
              :label="saveLabel"
              :loading="saving"
              :disable="(loading || !_.isEmpty(sessionInformation.rereportStudents)) && !$p(['ADMIN'])"
              style="margin-left:5px"
            />
            <q-btn color="purple"
                style="margin-left:5px"
                label="Rereport Students"
                v-if="sessionInformation.classStatus == 5 && !_.isEmpty(sessionInformation.rereportStudents)"
                :disabled="submitting || saving"
                @click="rereportMethod()" />&nbsp;
            <q-btn outline color="faded" v-show="!submitting && !issuing" @click.native="onCancel" label="Cancel" />
        </q-toolbar>
    </q-modal-layout>
    <q-inner-loading :visible="loading">
        <q-spinner-puff color="primary" size="70"></q-spinner-puff>
        <span v-show="submitting">Submitting</span>
        <span v-show="issuing">Issuing Certificates</span>
        <span v-show="rereporting">Reprocessing Certificates</span>
    </q-inner-loading>
    <confirm-modal
      :isOpen="showConfirmModal"
      :closeModal="closeConfirmModal"
      :onOk="onConfirm"
      title="Want faster processing?"
      body="Upload your roster now!"
      confirmText="Upload Roster"
      cancelText="No thanks"
    />
  </q-modal>
</template>

<style lang="stylus">
    @import '~variables'
    #classDetailsModal
        .navigation
            padding 24px
            overflow-x hidden
        .collapser
            position absolute
            height 50px
            left 0
            top 9px
            width 13px
            border 1px solid border-color
            border-left 0px
            z-index 100
            background #fff
            border-radius 0 5px 5px 0
            i
                position absolute
                top 18px
                margin-left 0px
                font-size 11px
            &:hover
                cursor pointer
                background #eee

        &.maximized
            .q-input,
            .q-datetime-input,
            h5
                transition(all .5s ease-in-out)
                opacity 1
        .approval-history
            font-size 19px
        #class-modal-right
            position relative
            height 100%
        #sessionDropdown
            .ellipsis
                overflow visible
        .total-students
            color text-color
            display inline-block
            padding-left 0
            padding-bottom 13px
            padding-top 20px
        .q-inner-loading
            z-index 9
        &.loading
            .q-input,
            .q-datetime-input
                margin-bottom 100px
                opacity 0
            h5
                margin-top 40px
                margin-bottom 60px
                opacity 0
        h5
            margin-top 30px
            margin-bottom 0
            @media (max-width: $breakpoint-sm)
                margin-top 0
            input[type="checkbox"]
                margin-left 20px
            span 
                font-size 13px
                vertical-align middle
        
        #addSession 
            float right
            padding 4px 10px
            margin-left 10px
            margin-right -16px
            @media (max-width: $breakpoint-sm)
                margin-right 0
                background $primary
                .q-icon
                    color #fff
        .relative
            position relative
            margin-bottom 20px
            .q-icon
                display block
                position absolute
                top 0
                right 17px
                align-items baseline
                vertical-align middle
                width 32px
                height 100%
                text-align center
                padding 6px 7px
                font-size 19px
                cursor pointer
                transition(all 0.2s ease-in-out)
                color toolbar-icon-color
                &:hover
                    color $negative
        #class-code
            position absolute
            bottom 5px
            left 0
            right 0
            display block
            @media (max-width: $breakpoint-sm)
                position static
            .q-if-label-above
                font-weight 600
                font-size 20px
                @media (max-width: $breakpoint-sm)
                    font-size 0.75rem
    #rejectionOverlay
        .q-btn
            margin-top 15px
            margin-right 6px
            &:last-child
                margin-right 0
</style>
